import { useDispatch } from 'react-redux';
import {
  BookingFormType,
  FormClosureObjectType,
  UpdateClosureObjectType,
} from '../../../redux/types/bookingTypes';
import styles from './ShowServiceTimeWindow.module.scss';
import { setModalWindowData } from '../../../redux/reducers/pageSlice';
import { ButtonType, ModalWindowTypes } from '../../../utils/@globalTypes';
import ModalWindow from '../ModalWindow';
import useValidationSchema from '../NewServiceTimeWindow/validationSchema';
import { useState } from 'react';
import { Form, Formik } from 'formik';
import { formatDate } from '../../Booking/functions';
import ClosureObjectHeader from '../../ClosureObjectComponents/ClosureObjectHeader';
import ScrollToError from '../../Booking/ScrollToError';
import ClosureObjectMain from '../../ClosureObjectComponents/ClosureObjectMain';
import {
  removeClosureObject,
  updateCurrentClosure,
} from '../../../redux/reducers/bookingSlice';
import Button from '../../Button';

const ShowServiceTimeWindow = ({ data }: any) => {
  const validationSchema = useValidationSchema();
  const dispatch = useDispatch();

  const [isEdit, setIsEdit] = useState(false); // переключение формы между просмотром и редактированием
  const windowType = isEdit ? BookingFormType.edit : BookingFormType.view;

  if (!data) {
    dispatch(setModalWindowData({ type: ModalWindowTypes.CLOSE }));
    return null;
  }
  const { closureItem, type } = data;

  const initialValues: FormClosureObjectType = {
    rental_object: closureItem.rental_object,
    start_closure: new Date(closureItem.start_closure),
    end_closure: new Date(closureItem.end_closure),
    reason: closureItem.reason,
  };
  const handleClickEdit = () => {
    setIsEdit(true);
  }; //переключение формы в режим редактирования
  const handleClickDelete = () => {
    dispatch(removeClosureObject(closureItem.id));
  };
  const close = () => {
    dispatch(setModalWindowData({ type: ModalWindowTypes.CLOSE }));
  };

  return (
    <ModalWindow
      isLoading={false}
      isFullCustom
      hideCross
      windowClassname={styles.window}
      isCloseOnOverlay={false}
    >
      <div className={styles.formContainer}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          validateOnBlur={false}
          validateOnChange={false}
          validateOnMount={false}
          onSubmit={(values: FormClosureObjectType) => {
            const newClosureObject: UpdateClosureObjectType = {};
            if (closureItem.rental_object !== values.rental_object) {
              newClosureObject.rental_object = values.rental_object;
            }
            if (
              closureItem.start_closure !== formatDate(values.start_closure)
            ) {
              newClosureObject.start_closure = formatDate(values.start_closure);
            }
            if (closureItem.end_closure !== formatDate(values.end_closure)) {
              newClosureObject.end_closure = formatDate(values.end_closure);
            }
            if (closureItem.reason !== values.reason) {
              newClosureObject.reason = values.reason;
            }
            const keys = Object.keys(newClosureObject).length;
            if (keys > 0) {
              try {
                dispatch(
                  updateCurrentClosure({
                    id: closureItem.id,
                    data: newClosureObject,
                  }),
                );
              } catch (error) {
                console.error('Ошибка отправки:', error);
              }
            }
          }}
        >
          {(formik) => (
            <Form>
              <ClosureObjectHeader
                windowType={windowType}
                formik={formik}
                handleClickEdit={handleClickEdit}
                handleClickDelete={handleClickDelete}
                windowClose={close}
              />
              <ScrollToError />
              <main className={styles.mainContainer}>
                <ClosureObjectMain windowType={windowType} formik={formik} />
                <div className={styles.btnSave}>
                  <Button
                    title="Сохранить"
                    disabled={!formik.dirty}
                    type={ButtonType.PRIMARY_SMALL}
                    actionType="submit"
                  />
                </div>
              </main>
            </Form>
          )}
        </Formik>
      </div>
    </ModalWindow>
  );
};

export default ShowServiceTimeWindow;
